import { IconButton, TextField } from "@mui/material";
import { forwardRef, useEffect, useState } from "react";
import { Clear } from "@mui/icons-material";
import { FormController } from "./Controller";

interface WrapperInputTextProps {
  name: string;
  label: string;
  placeholder?: string;
  value?: string | number;
  testid?: string;
  onChange?: any;
  disabled?: boolean;
}

const WrapperInputText = forwardRef(
  (
    {
      name,
      label,
      placeholder = "",
      value = "",
      testid = "jetest",
      onChange,
      ...props
    }: WrapperInputTextProps,
    ref: any
  ) => {
    const [inputValue, setInputValue] = useState(value !== null ? value : "");

    useEffect(() => {
      if (value !== inputValue) {
        setInputValue(value);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
      <TextField
        ref={ref}
        placeholder={placeholder}
        name={name}
        label={label}
        variant="outlined"
        onFocus={(e) => e.target.select()}
        inputProps={{
          ...(testid && { "data-testid": testid }),
        }}
        InputLabelProps={{ shrink: true }}

        InputProps={{
          ...(inputValue &&
            !props.disabled && {
              endAdornment: (
                <IconButton
                  aria-label="clear"
                  size="small"
                  onClick={() => {
                    setInputValue("");
                    onChange?.({ target: { value: "" } });
                  }}
                >
                  <Clear />
                </IconButton>
              ),
            }),
        }}
        style={{ width: "100%" }}
        value={inputValue}
        {...props}
        onChange={(e) => {
          setInputValue(e.target.value);
          onChange?.(e);
        }}
      />
    );
  }
);

interface InputTextProps {
  name?: string;
  withControl?: boolean;
  label: string;
  placeholder?: string;
  required?: boolean;
  row?: false | number;
  value?: string | number;
  rules?: any;
  onChange?: any;
}
export const InputText = ({
  name,
  withControl = true,
  label,
  placeholder,
  required = false,
  row = false,
  value = "",
  rules = {},
  ...rest
}: InputTextProps) => {
  const multiline = row ? { minRows: row, multiline: true } : {};

  if (withControl) {
    return (
      <FormController
        name={name}
        label={label}
        required={required}
        rules={rules}
      >
        {(props) => (
          <WrapperInputText
            {...rest}
            {...props}
            placeholder={placeholder}
            {...multiline}
          />
        )}
      </FormController>
    );
  }

  return (
    <WrapperInputText
      name={name}
      label={label}
      placeholder={placeholder}
      value={value ?? ""}
      {...multiline}
      {...rest}
    />
  );
};
